import { Slot, Skeleton, Text } from '@costar-ui/components';
import React from 'react';

var Address = function Address(props) {
  var lines = props.lines,
    skeletonCount = props.skeletonCount,
    testId = props.testId,
    isLoading = props.isLoading;
  return isLoading ? /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    gap: "xs",
    className: "csg-tw-skeleton-address"
  }, skeletonCount === 2 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  })) : skeletonCount === 3 ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  })) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }), /*#__PURE__*/React.createElement(Skeleton, {
    width: "full",
    height: "1.25"
  }))) : lines && /*#__PURE__*/React.createElement(Slot, {
    direction: "vertical",
    testId: "address-".concat(testId)
  }, lines === null || lines === void 0 ? void 0 : lines.map(function (value, index) {
    return /*#__PURE__*/React.createElement(Text, {
      key: value + index,
      "automation-id": "address-line-".concat(index),
      className: "wrap-anywhere",
      variant: "text-16"
    }, value);
  }));
};

export { Address };
//# sourceMappingURL=address.esm.js.map
